import isVideoImage from './isVideoImage';

// A product's still images (video slots removed) in gallery order — for places where only real
// images make sense, e.g. JSON-LD structured data. See productCoverImage for just the first still.
const productStillImages = (product) =>
  (product?.images ?? []).filter((image) => !isVideoImage(image));

export default productStillImages;
